var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: "flex-grow-1 align-content-center w-100 p-2" },
    [
      _c(
        "router-link",
        {
          staticClass: "pointer h-100",
          attrs: { to: { name: _vm.getRoute() }, tag: "div" }
        },
        [
          _c(
            "div",
            {
              ref: "boutoncontainer",
              class:
                _vm.data.color +
                " " +
                _vm.getTextColor(_vm.data.color) +
                " contenu-button rounded d-flex w-100 h-100 align-items-center p-2"
            },
            [
              _c("icon", {
                staticClass: "iconHome ms-3 me-3",
                staticStyle: { fill: "#fff" },
                attrs: { name: _vm.data.icon }
              }),
              _c("p", [_vm._v(_vm._s(_vm.data.label))])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }